import { useMemo } from 'react';

import { useCollectionContext } from '../contexts/CollectionContext';
import {
	canCreateItems,
	canManage,
	canRead,
	canReadCard,
	canWrite,
	canWriteCard,
	accessibleCardIds,
	getMyAccess,
	isCardScoped,
	isOwner,
	roleLabel,
} from '../utils/permissions';

/**
 * The active collection's permission surface, bound to CollectionContext.
 * All flags derive from the server-computed myAccess annotation (see
 * utils/permissions.js) — render-honesty only; the server re-checks
 * everything.
 */
export default function useCollectionAccess() {
	const context = useCollectionContext();
	const collection = context?.collection || null;

	return useMemo(() => ({
		collection,
		access: getMyAccess(collection),
		canRead: canRead(collection),
		canWrite: canWrite(collection),
		canManage: canManage(collection),
		canCreateItems: canCreateItems(collection),
		isOwner: isOwner(collection),
		isCardScoped: isCardScoped(collection),
		accessibleCardIds: accessibleCardIds(collection),
		roleLabel: roleLabel(collection),
		canReadCard: cardId => canReadCard(collection, cardId),
		canWriteCard: cardId => canWriteCard(collection, cardId),
	}), [collection]);
}
